import { registerComponent, Component, Entity, Object3DSetEvent } from "aframe";
import { Object3D } from "three";


interface ParentComponent extends Component
{
	locationPending : boolean;
	data : string;
	setParent(obj : Object3D, key : string) : void;
}



registerComponent("parent", {
	
	schema : { type : "string" },

	init(this : ParentComponent)
	{
		this.locationPending = true;
		this.el.object3D.visible = false; // Hide until real parent is found
	},
	
	setParent(this : ParentComponent, parent : Object3D, key : string)
	{
		parent.add(this.el.object3D);
		
		this.el.emit("parent-object-changed", parent, false );

		if( key )
		{
			(this.el.parentElement as Entity).addEventListener("object3dset", (event) => {
				if(event.detail.type == key)
					this.update(null);
			});
		}

		if(this.el.parentEl && (parent !== this.el.parentEl.object3D))
		{
			const visibleComp = this.el.components.visible;
			if(!visibleComp)
				this.el.object3D.visible = true;

			this.locationPending = false;
			this.el.emit('location-initialized', this, false );

		}
	},
	
	update(this: ParentComponent)
	{
		this.el.emit("reset-parent-component", null, false); //Cancel previous attempt.
		
		const parentEl = this.el.parentElement as Entity, parentName = this.data;

		for(let key in parentEl.object3DMap)
		{
			const mapObj = parentEl.object3DMap[key];
			if(mapObj.name == parentName)
				return this.setParent(mapObj, key);

			const mapChild = mapObj.getObjectByName(parentName);
			if(mapChild)
				return this.setParent(mapChild, key); //Found in already-loaded.
				
		}

		//Add to parentEl until better match...
		this.setParent(parentEl.object3DMap[parentName] || parentEl.object3D, "");

		if(!parentName)
			return;

		const onNewObject = (event : Object3DSetEvent) => 
		{
			if(event.target !== parentEl) return;
			if(event.detail.object.name == parentName)
				return this.setParent(event.detail.object, event.detail.type);
			const child = event.detail.object.getObjectByName(parentName);
			if(child)
				return this.setParent(child, event.detail.type);
			if(event.detail.type == parentName)
				return this.setParent(event.detail.object, event.detail.type);
		}
		const reset = () =>
		{
			parentEl.removeEventListener("object3dset", onNewObject as EventListener);
			this.el.removeEventListener("reset-parent-component", reset);
			this.el.removeEventListener("parent-object-changed", reset);
		}
		
		parentEl.addEventListener("object3dset", onNewObject);
		this.el.addEventListener("reset-parent-component", reset);
		this.el.addEventListener("parent-object-changed", reset);
	}
})

